import React from 'react';
import SeguimientoEncomienda from './components/seguimiento/SeguimientoEncomienda';
import './App.css';

function App() {
  return (
    <div className="App">
      <SeguimientoEncomienda />
    </div>
  );
}

export default App;